<template>
  <div class="task-show">
    <div class="box" v-for="(tasks, index) of taskListGroup(taskList, 5)" :key="index">
      <div
        v-for="(task, idx) of tasks"
        :key="idx"
        class="task-wrapper"
        @click="handleClickToExpertDetail(task)"
      >
        <img :src="task.image" class="task-img" />
        <div class="task-name">{{ task.fullName }}</div>
        <div class="task-desc">{{ task.rank }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TaskShow",
  props: {
    expertList: Array,
  },
  data() {
    return {};
  },
  computed: {
    taskList() {
      return this.expertList;
    },
  },
  mounted() {},
  methods: {
    taskListGroup(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      if (array && array.length) {
        while (index < array.length) {
          newArray.push(array.slice(index, (index += subGroupLength)));
        }
        return newArray;
      }
    },
    handleClickToExpertDetail(task) {
      this.$router.push({
        path: "ExpertDetail",
        query: {
          id: task.id,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.task-show {
  height: 584px;
  .box {
    display: flex;
    justify-content: left;
    text-align: center;
    margin-bottom: 50px;
    .task-wrapper {
      margin-right: 124px;
      &:hover .task-img {
        transition: 1s;
        transform: rotate(360deg);
      }
    }
    .task-img {
      width: 150px;
      height: 150px;
      border-radius: 50%;
    }
    .task-name {
      padding-top: 24px;
      line-height: 24px;
      font-size: 19px;
    }
    .task-desc {
      height: 44px;
      line-height: 44px;
      font-size: 16px;
      color: #aaa;
    }
  }
}
</style>
